module.exports = __webpack_public_path__ + "img/menu-line.479b450f.svg";